import React, { useEffect, useState } from "react";
import { MdUpload } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import { EditWhoWeAreApi } from "Services/allApi";
import { whoWeAreApi } from "Services/allApi";


function WhoWeAre() {
  const [formData, setFormData] = useState({
    image1: "",
    image2: "",
    heading_section_1: "",
    heading_section_2: "",
    heading_section_3: "",
    description: "",
    btn_content: "",
    btn_url: "",
  });

  const [currentImages, setCurrentImages] = useState({ image1: "", image2: "" });

  const [id, setId] = useState(null);
  

  useEffect(() => {
    const fetchData = async () => {
    //   setLoading(true);
      try {
        const response = await whoWeAreApi();
        if (response.error) {
          toast.error(`Error: ${response.message}`);
        } else if (response.data && response.data.length > 0) {
          const data = response.data[0];
          setId(data.id);
          setFormData({
           
            image1: "",
            image2: "",
            heading_section_1: data.heading_section_1 || "",
            heading_section_2: data.heading_section_2 || "",
            heading_section_3: data.heading_section_3 || "",
            description: data.description || "",
            btn_content: data.btn_content || "",
            btn_url: data.btn_url || "",
          });
          setCurrentImages({
            image1: data.image1 || "",
            image2: data.image2 || "",
          });
        } else {
          toast.error("Data not found or response format is invalid.");
        }
      } catch (error) {
        toast.error("Failed to fetch data. Please try again.");
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData({
          ...formData,
          [e.target.id]: file,
        });
        setCurrentImages({
          ...currentImages,
          [e.target.id]: reader.result,
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    const form = new FormData();

    Object.keys(formData).forEach((key) => {
        if (formData[key]) {
            form.append(key, formData[key]);
        }
    });

    try {
        const response = await EditWhoWeAreApi(id, form);
        console.log("Full API Response:", response); // ✅ This is the actual data

        // ✅ Directly check if response exists
        if (response && response.id) { 
            toast.success("Updated successfully!", { autoClose: 2000 });
        } else {
            toast.error(`Update failed: Unexpected API response`);
        }
    } catch (error) {
        console.error("Update error:", error);
        toast.error("Failed to update. Please try again.");
    }
};


  return (
    <div>
      <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
      <h2 className="text-center text-3xl font-bold mb-5 mt-2">Who We Are</h2>
      <hr className="mb-4" />
        <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
          {/* Image 1 */}
          <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
            <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
              {currentImages.image1 && (
                <img
                  src={currentImages.image1}
                  alt="Current Image 1"
                  className="rounded shadow-md"
                  style={{ height: "130px",width:"150px" }}
                />
              )}
            </div>
            <div className="sm:w-1/2 text-center">
              <label htmlFor="image1" className="block font-medium text-gray-900 mb-2">Image 1</label>
              <input
                type="file"
                id="image1"
                accept="image/*"
                className="hidden"
                onChange={handleImageUpload}
              />
              <button
                type="button"
                onClick={() => document.getElementById("image1").click()}
                className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
              >
                <MdUpload />
              </button>
              <p className="mt-2" style={{fontSize:'10px'}}>The height and width must be 263 × 263</p>
            </div>
          </div>

          {/* Image 2 */}
          <div className="sm:col-span-2 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
            <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
              {currentImages.image2 && (
                <img
                  src={currentImages.image2}
                  alt="Current Image 2"
                  className="rounded shadow-md"
                  style={{ height: "130px",width:"150px" }}
                />
              )}
            </div>
            <div className="sm:w-1/2 text-center">
              <label htmlFor="image2" className="block font-medium text-gray-900 mb-2">Image 2</label>
              <input
                type="file"
                id="image2"
                accept="image/*"
                className="hidden"
                onChange={handleImageUpload}
              />
              <button
                type="button"
                onClick={() => document.getElementById("image2").click()}
                className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
              >
                <MdUpload />
              </button>
              <p className="mt-2" style={{fontSize:'10px'}}>The height and width must be 400 × 483</p>
            </div>
          </div>

          {/* Heading Section 1 */}
          <div className="sm:col-span-2">
                        <label htmlFor="headingSection1" className="block font-medium text-gray-900">Heading Section 1</label>
                        <div className="mt-2">
                            <input
                                type="text"
                                name="heading_section_1"
                                id="heading_section_1"
                                value={formData.heading_section_1}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                            /> 
                        </div>
                    </div>

                    {/* Heading Section 2 */}
                    <div className="sm:col-span-2">
                        <label htmlFor="headingSection2" className="block font-medium text-gray-900">Heading Section 2</label>
                        <div className="mt-2">
                            <input
                                type="text"
                                name="heading_section_2"
                                id="heading_section_2"
                                value={formData.heading_section_2}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                            />
                        </div>
                    </div>

                    {/* Heading Section 3 */}
                    <div className="sm:col-span-4">
                        <label htmlFor="headingSection3" className="block font-medium text-gray-900">Heading Section 3</label>
                        <div className="mt-2">
                            <input
                                type="text"
                                name="heading_section_3"
                                id="heading_section_3"
                                value={formData.heading_section_3}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                            />
                        </div>
                    </div>

                    {/* Description */}
                    <div className="sm:col-span-4">
                        <label htmlFor="description" className="block font-medium text-gray-900">Description</label>
                        <div className="mt-2">
                            <textarea
                                type="text"
                                name="description"
                                id="description"
                                value={formData.description}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                            />
                        </div>
                    </div>

                    {/* Button Content */}
                    <div className="sm:col-span-2">
                        <label htmlFor="btn_content" className="block font-medium text-gray-900">Button Content</label>
                        <div className="mt-2">
                            <input
                                type="text"
                                name="btn_content"
                                id="btn_content"
                                value={formData.btn_content}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                            />
                        </div>
                    </div>

                    {/* Button URL */}
                    <div className="sm:col-span-2">
                        <label htmlFor="btn_url" className="block font-medium text-gray-900">Button URL</label>
                        <div className="mt-2">
                            <input
                                type="text"
                                name="btn_url"
                                id="btn_url"
                                value={formData.btn_url}
                                onChange={handleInputChange}
                                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                            />
                        </div>
                    </div>
                </div>
                <hr  className='mt-5 mb-4'/>
        <div className="flex justify-center mt-6">
       
          <button
            type="button"
            onClick={handleSubmit}
            className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
           
          >
           Update
          </button>
        </div>

        
      </div>
            
    </div>
  );
}

export default WhoWeAre;
